
export enum ClaimantSameAsCd {
	BILL_TO = 'Bill-To',
	CONSIGNEE = 'Consignee',
	SHIPPER = 'Shipper'}

